import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Form, Link, useNavigate } from 'react-router-dom';
import logo from '../../../Components/home/images/logo.png';
import coupleImage from '../../../assets/images/couples/Vector.png';
// import apiConfig from '../../../config/api';
import Select from "react-select";
import { FaEye, FaEyeSlash } from "react-icons/fa"

import { SignupContext } from "../../../context/SignupContext";
// import { IoCompassOutline } from 'react-icons/io5';
import { LoginContext } from '../../../context/LoginContext';

const SignupForm = () => {
  const navigate = useNavigate();

  const { setUserName, setAPIFormData, setUserId, setIsLoggedIn } = useContext(SignupContext);

  const { userId, isLoggedIn } = useContext(LoginContext);



  // geting ip section start 
  const [clientIp, setClientIp] = useState("no ip");
  const getData = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    setClientIp(res.data.ip);
  };
  // getting ip section end 


  // Form state
  const [formData, setFormData] = useState({
    name: '',
    gender: '',
    looking_for: '',
    dob: '',
    caste: '',
    profile_for: '',
    language: '',
    highest_education: '',
    family_type: '',
    country: { label: "India", value: '101' },
    state: '',
    hobbies: '',
    height: '',
    occupation: '',
    email: '',
    password: '',
    terms_accepted: true,
    ip: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [options, setOptions] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


  const currentDate = new Date();
  const currentYear = currentDate.getFullYear(); // Get the current year
  let currentMonth = currentDate.getMonth(); // Get the month year
  if (currentMonth < 10) {
    currentMonth = "0" + currentMonth;
  }
  const maxDOB = `${(currentYear - 21)}-${currentMonth}-01`;
  const minDOB = `${(currentYear - 60)}-${currentMonth}-01`;

  const handleNameChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newName;
    let myName;
    if (value.length > 1) {
      newName = value.split(" ");
      myName = newName.map(str => str.charAt(0).toUpperCase() + str.slice(1)).join(" ");
    } else {
      myName = value;
    }
    setFormData(prev => ({
      ...prev,
      [name]: myName
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

  };

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleLookingForChange = (name, selectedOption) => {
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption,
      gender: (selectedOption.value === 'Bride') ? { label: "Male", value: "Male" } : (selectedOption.value === 'Groom' ? { label: "Female", value: "Female" } : { label: "Others", value: "Others" })
    }));
  };

  const handleGenderChange = (name, selectedOption) => {
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption,
      looking_for: (selectedOption.value === 'Male') ? { label: "Bride", value: "Bride" } : (selectedOption.value === 'Female' ? { label: "Groom", value: "Groom" } : { label: "Bride", value: "Bride" })
    }));
  };

  // Handle select changes
  const handleSelectChange = (name, selectedOption) => {
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption
    }));
  };

  // Handle country changes
  const handlecountryChange = async (name, selectedOption) => {
    setIsLoading(true);
    const resp = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/state.php?country=${selectedOption.value}`
    );
    setOptions(prev => ({
      ...prev,
      states: Array.isArray(resp.data.data.states) ? resp.data.data.states : [],
    }));
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption,
      state: ""
    }));
    setIsLoading(false);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = 'Full name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/^\S+@\S+\.\S+$/.test(formData.email)) newErrors.email = 'Email is invalid';
    if (!formData.dob) newErrors.dob = 'Date of birth is required';
    if (!formData.looking_for) newErrors.looking_for = 'Please Select Looking For';
    if (!formData.gender) newErrors.gender = 'Gender is required';
    // if (!formData.religion) newErrors.religion = 'Religion is required';
    if (!formData.caste) newErrors.caste = 'Caste is required';
    if (!formData.hobbies) newErrors.hobbies = 'Hobbies is required';
    if (!formData.profile_for) newErrors.profile_for = 'Please Select Profile For';
    if (!formData.language) newErrors.language = 'Please Select Language';
    if (!formData.highest_education) newErrors.highest_education = 'Please Select Highest Education';
    if (!formData.family_type) newErrors.family_type = 'Please Select Family Type';
    if (!formData.height) newErrors.height = 'Please Select Height';
    if (!formData.occupation) newErrors.occupation = 'Please Select Occupation';
    if (!formData.state) newErrors.state = 'Please Select State';
    if (!formData.country) newErrors.country = 'Country is required';
    if (!formData.password) newErrors.password = 'Password is required';
    else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';
    if (!formData.terms_accepted) newErrors.terms_accepted = 'You must accept terms';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const calculateAge = (birthdate) => {
    const today = new Date();
    const birthdateDate = new Date(birthdate);

    let calculatedAge = today.getFullYear() - birthdateDate.getFullYear();
    const monthDiff = today.getMonth() - birthdateDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdateDate.getDate())) {
      calculatedAge--;
    }
    return (calculatedAge);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      // setFormData({    ip: clientIp});
      // for (let key in formData) {
      //   // The backend expects 'pwd' instead of 'password'
      //   if (key === 'password') {

      //     payload.append('pwd', formData[key]);
      //   } else {
      //     payload.append(key, formData[key]);
      //   }
      // }

      const payload = new FormData();

      payload.append("name", formData.name);
      payload.append("gender", formData.gender.value);
      payload.append("looking_for", formData.looking_for.value);
      payload.append("dob", formData.dob);
      payload.append("caste", formData.caste.value);
      payload.append("pro_for", formData.profile_for.value);
      payload.append("language", formData.language.value);
      payload.append("high_education", formData.highest_education.value);
      payload.append("family_type", formData.family_type.value);
      payload.append("country", formData.country.label);
      payload.append("state", formData.state.label);
      payload.append("height", formData.height.value);
      payload.append("occupation", formData.occupation.value);
      const myHobbies = Object.values(formData.hobbies.map((val, i) => ((i == 0) ? (val.value) : (` ${val.value}`))));
      payload.append("hobbies", myHobbies);
      payload.append("email", formData.email);
      payload.append("pwd", formData.password);

      payload.append('ip', clientIp);
      const dobAge = calculateAge(formData.dob);
      let ProfileBy = "Myself";
      if (formData.profile_for.value == "Self") {
        ProfileBy = "Myself";
      } else if (formData.profile_for.value == "Son" || formData.profile_for.value == "Daughter") {
        ProfileBy = "My Parents";
      } else if (formData.profile_for.value == "Brother") {
        ProfileBy = "My Sister";
      } else if (formData.profile_for.value == "Sister") {
        ProfileBy = "My Brother";
      } else if (formData.profile_for.value == "Friend") {
        ProfileBy = "My Friend";
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}Register_controller/register`,
        payload
      );

      if (response.data.status) {
        //////use context api
        setAPIFormData({ email: (formData.email), age: dobAge, height: (formData.height.value), profileFor: (ProfileBy), language: (formData.language.value), family_type: (formData.family_type.value), highest_education: (formData.highest_education.value), occupation: (formData.occupation.value), hobbies: myHobbies, country: formData.country, state: formData.state });
        setUserName(formData['name']);
        setIsLoggedIn(true);
        setUserId(response.data.id);

        navigate('/send-otp');
      } else {
        setErrors({
          api: response.data.message || 'Registration failed',
          ...(response.data.errors || {})
        });
      }
    } catch (error) {
      console.error('Registration error:', error);
      setErrors({
        api: error.response?.data?.message || 'Something went wrong. Please try again.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  /////calling caste api

  // Fetch all dropdown options
  useEffect(() => {

    if (isLoggedIn) {
      navigate('/recently-joined-matches');
    }

    const fetchOptions = async () => {

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`
        );
        const resp = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/education.php`
        );

        if (!response.data.success) {
          throw new Error(response.data.error || "Failed to fetch options");
        }

        // Transform all options to ensure they're arrays
        const transformedOptions = {
          caste: Array.isArray(response.data.data.caste) ? response.data.data.caste : [],
          gothra: Array.isArray(response.data.data.gothra) ? response.data.data.gothra : [],
          cities: Array.isArray(response.data.data.cities) ? response.data.data.cities : [],
          countries: Array.isArray(response.data.data.countries) ? response.data.data.countries : [],
          income: Array.isArray(response.data.data.income) ? response.data.data.income : [],
          language: Array.isArray(response.data.data.language) ? response.data.data.language : [],
          states: Array.isArray(response.data.data.states) ? response.data.data.states : [],
          education: Array.isArray(resp.data.data.education) ? resp.data.data.education : [],
          occupation: Array.isArray(resp.data.data.occupation) ? resp.data.data.occupation : [],
        };

        setOptions(transformedOptions);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching options:", err);
        setOptions({
          caste: [],
          gothra: [],
          cities: [],
          countries: [],
          income: [],
          states: [],
          education: [],
          occupation: [],
        });
      }
    };

    fetchOptions();
  }, []);




  return (
    <>

      {isLoading && <div className='custom-loader-g'>
        <div class="spinner-border text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>}

      <div className='py-5'></div>

      <div className="page-container">
        <div className="login-container">
          <div className="signup-wrapper" onLoad={getData}>
            <div className="form-section">

              <h2 className=''>Create your account </h2>
              {/* <p className="subtext">Let's get started</p> */}

              {errors.api && <div className="error-message" style={{ color: 'red', marginBottom: '15px' }}>{errors.api}</div>}

              <form className="form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <label>
                    Full Name *
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleNameChange}
                      placeholder="Enter your name"
                    />
                    {errors.name && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.name}</span>}
                  </label>

                  <label>
                    Religion *
                    <input readOnly
                      type="text"
                      name="religion"
                      value="Hindu"
                      placeholder="Enter your religion"
                    />
                  </label>

                </div>

                <div className="form-row">

                  <label>
                    Gender *

                    <Select
                      options={Array("Male", "Female").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.gender}
                      onChange={(selected) => handleGenderChange("gender", selected)}
                      placeholder="Select Gender" />


                    {errors.gender && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.gender}</span>}
                  </label>

                  <label>
                    Looking For *

                    <Select
                      options={Array("Bride", "Groom").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.looking_for}
                      onChange={(selected) => handleLookingForChange("looking_for", selected)}
                      placeholder="Looking For"
                    />

                    {errors.looking_for && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.looking_for}</span>}
                  </label>
                </div>






                <div className="form-row">
                  <label>
                    Date of Birth *
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}

                      max={maxDOB}
                      min={minDOB}

                    />
                    {errors.dob && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.dob}</span>}
                  </label>

                  <label>
                    Caste  *



                    <Select
                      options={options?.caste?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.caste}
                      onChange={(selected) => handleSelectChange("caste", selected)}
                      placeholder="Select caste"
                    />

                    {errors.caste && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.caste}</span>}
                  </label>

                </div>

                <div className="form-row">


                  <label>
                    Create Profile For *


                    <Select
                      options={Array("Self", "Son", "Daughter", "Brother", "Sister", "Friend").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.profile_for}
                      onChange={(selected) => handleSelectChange("profile_for", selected)}
                      placeholder="Profile For"
                    />

                    {errors.profile_for && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.profile_for}</span>}

                  </label>


                  <label>
                    Mother Tounge / Language *
                    <Select
                      options={options?.language?.map(lang => ({
                        label: lang,
                        value: lang
                      }))}

                      value={formData.lang}
                      onChange={(selected) => handleSelectChange("language", selected)}
                      placeholder="Select Language"
                      isDisabled={options?.language?.length === 0}
                    />
                    {errors.language && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.language}</span>}
                  </label>
                </div>





                <div className="form-row">

                  <label>
                    Education  *

                    {/* Array("Not Educated", "10th Pass", "12th Pass", "Diploma", "Graduate", "M Phil", "PHD", "Other") */}
                    <Select
                      options={Array("Not Educated", "10th Pass", "12th Pass", "Diploma", "Graduate", "Post Graduate", "M Phil", "PHD", "Other").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.highest_education}
                      onChange={(selected) => handleSelectChange("highest_education", selected)}
                      placeholder="Select Highest Education"
                    />

                    {errors.highest_education && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.highest_education}</span>}
                  </label>


                  <label>
                    Family Type *


                    <Select
                      options={Array("Joint Family", "Nuclear Family").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.family_type}
                      onChange={(selected) => handleSelectChange("family_type", selected)}
                      placeholder="Select Family Type"
                    />


                    {/* <select name="family_type" class="form-control">
                <option selected="" disabled="">Not Filled</option>
                <option value="Joint Family">Joint Family</option>
                <option value="Nuclear Family">Nuclear Family</option>
              </select> */}
                    {errors.family_type && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.family_type}</span>}
                  </label>


                </div>


                <div className="form-row">

                  <label>
                    Country *

                    <Select
                      options={options?.countries?.map((o) => ({
                        label: Object.values(o).toString(),
                        value: Object.keys(o).toString()
                      }))}

                      value={formData.country}
                      onChange={(selected) => handlecountryChange("country", selected)}
                      placeholder="Select Country"
                    />


                    {/* <select name="family_type" class="form-control">
                <option selected="" disabled="">Api Fetch</option>

              </select> */}
                    {errors.religion && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.religion}</span>}
                  </label>


                  <label>
                    State *
                    <Select
                      options={options?.states?.map(val => ({
                        label: Object.values(val).toString(),
                        value: Object.keys(val).toString()
                      }))}

                      value={formData.state}
                      onChange={(selected) => handleSelectChange("state", selected)}
                      placeholder="Select State"
                    // defaultValue={{ label: "Delhi", value: "Delhi" }}
                    />


                    {/* <select name="family_type" class="form-control">
                <option selected="" disabled="">Api Fetch</option>

              </select> */}
                    {errors.state && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.state}</span>}
                  </label>


                </div>

                <div className="form-row">



                  <label>
                    Hobbies *


                    <Select
                      options={[
                        {
                          label: "Creative & Artistic",
                          options: [
                            { value: "drawing", label: "Drawing" },
                            { value: "painting", label: "Painting" },
                            { value: "writing", label: "Writing" },
                            { value: "photography", label: "Photography" },
                            { value: "calligraphy", label: "Calligraphy" },
                            { value: "scrapbooking", label: "Scrapbooking" },
                            { value: "sewing", label: "Sewing" },
                            { value: "knitting", label: "Knitting" },
                            { value: "crocheting", label: "Crocheting" },
                            { value: "woodworking", label: "Woodworking" },
                            { value: "metalworking", label: "Metalworking" },
                            { value: "lego", label: "LEGO Building" },
                            { value: "model_building", label: "Model Building" },
                            { value: "home_decor", label: "Home Decor" },
                            { value: "interior_design", label: "Interior Design" },
                          ],
                        },
                        {
                          label: "Performance & Entertainment",
                          options: [
                            { value: "dancing", label: "Dancing" },
                            { value: "singing", label: "Singing" },
                            { value: "playing_music", label: "Playing Musical Instruments" },
                            { value: "acting", label: "Acting" },
                            { value: "magic", label: "Magic Tricks" },
                            { value: "vlogging", label: "Vlogging" },
                            { value: "podcasting", label: "Podcasting" },
                            { value: "blogging", label: "Blogging" },
                          ],
                        },
                        {
                          label: "Outdoor & Physical",
                          options: [
                            { value: "hiking", label: "Hiking" },
                            { value: "camping", label: "Camping" },
                            { value: "fishing", label: "Fishing" },
                            { value: "gardening", label: "Gardening" },
                            { value: "cycling", label: "Cycling" },
                            { value: "running", label: "Running" },
                            { value: "swimming", label: "Swimming" },
                            { value: "yoga", label: "Yoga" },
                            { value: "meditation", label: "Meditation" },
                            { value: "surfing", label: "Surfing" },
                            { value: "skateboarding", label: "Skateboarding" },
                            { value: "skiing", label: "Skiing" },
                            { value: "snowboarding", label: "Snowboarding" },
                            { value: "horseback_riding", label: "Horseback Riding" },
                            { value: "archery", label: "Archery" },
                            { value: "martial_arts", label: "Martial Arts" },
                          ],
                        },
                        {
                          label: "Tech & Digital",
                          options: [
                            { value: "gaming", label: "Gaming" },
                            { value: "coding", label: "Coding" },
                            { value: "robotics", label: "Robotics" },
                            { value: "3d_printing", label: "3D Printing" },
                            { value: "investing", label: "Investing" },
                            { value: "language_learning", label: "Learning Languages" },
                          ],
                        },
                        {
                          label: "Culinary",
                          options: [
                            { value: "cooking", label: "Cooking" },
                            { value: "baking", label: "Baking" },
                          ],
                        },
                        {
                          label: "Mind & Collection",
                          options: [
                            { value: "reading", label: "Reading" },
                            { value: "puzzles", label: "Puzzles" },
                            { value: "board_games", label: "Board Games" },
                            { value: "collecting_stamps", label: "Stamp Collecting" },
                            { value: "collecting_coins", label: "Coin Collecting" },
                            { value: "birdwatching", label: "Birdwatching" },
                            { value: "bird_breeding", label: "Bird Breeding" },
                            { value: "geocaching", label: "Geocaching" },
                            { value: "astrology", label: "Astrology" },
                            { value: "astronomy", label: "Astronomy" },
                          ],
                        },
                        {
                          label: "Media & Entertainment",
                          options: [
                            { value: "movies", label: "Watching Movies" },
                            { value: "tv_series", label: "Watching TV Series" },
                            { value: "anime", label: "Watching Anime" },
                            { value: "traveling", label: "Traveling" },
                          ],
                        },
                        {
                          label: "Community & Social",
                          options: [
                            { value: "volunteering", label: "Volunteering" },
                          ],
                        }
                      ]}


                      value={formData.hobbies}
                      onChange={(selected) => handleSelectChange("hobbies", selected)}
                      placeholder="Select Hobbies"
                      isMulti={true}
                    />

                    {/* <select name="hobbies" id="hobbies">
                <option value="">Select a Hobby</option>

                <optgroup label="Creative & Artistic">
                  <option value="drawing">Drawing</option>
                  <option value="painting">Painting</option>
                  <option value="writing">Writing</option>
                  <option value="photography">Photography</option>
                  <option value="calligraphy">Calligraphy</option>
                  <option value="scrapbooking">Scrapbooking</option>
                  <option value="sewing">Sewing</option>
                  <option value="knitting">Knitting</option>
                  <option value="crocheting">Crocheting</option>
                  <option value="woodworking">Woodworking</option>
                  <option value="metalworking">Metalworking</option>
                  <option value="lego">LEGO Building</option>
                  <option value="model_building">Model Building</option>
                  <option value="home_decor">Home Decor</option>
                  <option value="interior_design">Interior Design</option>
                </optgroup>

                <optgroup label="Performance & Entertainment">
                  <option value="dancing">Dancing</option>
                  <option value="singing">Singing</option>
                  <option value="playing_music">Playing Musical Instruments</option>
                  <option value="acting">Acting</option>
                  <option value="magic">Magic Tricks</option>
                  <option value="vlogging">Vlogging</option>
                  <option value="podcasting">Podcasting</option>
                  <option value="blogging">Blogging</option>
                </optgroup>

                <optgroup label="Outdoor & Physical">
                  <option value="hiking">Hiking</option>
                  <option value="camping">Camping</option>
                  <option value="fishing">Fishing</option>
                  <option value="gardening">Gardening</option>
                  <option value="cycling">Cycling</option>
                  <option value="running">Running</option>
                  <option value="swimming">Swimming</option>
                  <option value="yoga">Yoga</option>
                  <option value="meditation">Meditation</option>
                  <option value="surfing">Surfing</option>
                  <option value="skateboarding">Skateboarding</option>
                  <option value="skiing">Skiing</option>
                  <option value="snowboarding">Snowboarding</option>
                  <option value="horseback_riding">Horseback Riding</option>
                  <option value="archery">Archery</option>
                  <option value="martial_arts">Martial Arts</option>
                </optgroup>

                <optgroup label="Tech & Digital">
                  <option value="gaming">Gaming</option>
                  <option value="coding">Coding</option>
                  <option value="robotics">Robotics</option>
                  <option value="3d_printing">3D Printing</option>
                  <option value="investing">Investing</option>
                  <option value="language_learning">Learning Languages</option>
                </optgroup>

                <optgroup label="Culinary">
                  <option value="cooking">Cooking</option>
                  <option value="baking">Baking</option>
                </optgroup>

                <optgroup label="Mind & Collection">
                  <option value="reading">Reading</option>
                  <option value="puzzles">Puzzles</option>
                  <option value="board_games">Board Games</option>
                  <option value="collecting_stamps">Stamp Collecting</option>
                  <option value="collecting_coins">Coin Collecting</option>
                  <option value="birdwatching">Birdwatching</option>
                  <option value="bird_breeding">Bird Breeding</option>
                  <option value="geocaching">Geocaching</option>
                  <option value="astrology">Astrology</option>
                  <option value="astronomy">Astronomy</option>
                </optgroup>

                <optgroup label="Media & Entertainment">
                  <option value="movies">Watching Movies</option>
                  <option value="tv_series">Watching TV Series</option>
                  <option value="anime">Watching Anime</option>
                  <option value="traveling">Traveling</option>
                </optgroup>

                <optgroup label="Community & Social">
                  <option value="volunteering">Volunteering</option>
                </optgroup>




              </select> */}
                    {errors.hobbies && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.hobbies}</span>}
                  </label>


                  <label>
                    Email ID *
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                    />
                    {errors.email && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.email}</span>}
                  </label>

                </div>



                <div className='form-row'>

                  <label >
                    Height (in feet) *
                    <Select
                      options={Array.from({ length: 4 }, (_, f) => 4 + f) // 4 to 7
                        .flatMap(feet =>
                          Array.from({ length: 12 }, (_, inches) => {
                            if (feet === 7 && inches > 0) return null;
                            return { label: `${feet}.${inches} Ft`, value: `${feet}.${inches}` }
                          }).filter(Boolean)
                        )}
                      value={formData.height}
                      onChange={(selected) => handleSelectChange("height", selected)}
                      placeholder="Select Height"

                    />
                    {errors.height && <span className="field-error" style={{
                      color: 'red',
                      fontSize: '12px'
                    }}>{errors.height}</span>}

                  </label>

                  <label>
                    Occupation *
                    <Select
                      options={options?.occupation?.map(res => ({ label: res, value: res }))}
                      value={formData.occupation}
                      onChange={(selected) => handleSelectChange("occupation", selected)}
                      placeholder="Select Occupation"

                    />
                    {errors.occupation && <span className="field-error" style={{
                      color: 'red',
                      fontSize: '12px'
                    }}>{errors.occupation}</span>}

                  </label>
                </div>









                <div className="form-group">
                  <label className='mb-2'>Password *</label>
                  <div className='input-group mb-0'>
                    <input
                      style={{ flex: 1, marginTop: 0 }}
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      aria-label="Enter your password"
                      aria-describedby="basic-addon2"

                    />
                    <span class="input-group-text" id="basic-addon2 p-1"
                      onClick={() => (setShowPassword((prev) => !prev))}
                      style={{ cursor: 'pointer', borderRadius: "0 15px 15px 0" }}> {showPassword ? <FaEye size={22} /> :
                        <FaEyeSlash size={22} />} </span>
                  </div>
                  {errors.password && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.password}</span>}
                </div>

                <div className="checkbox"   >
                  <input
                    type="checkbox"
                    id="terms"
                    name="terms_accepted"
                    checked={formData.terms_accepted}
                    onChange={handleChange}
                  />
                  <label htmlFor="terms">
                    I hereby agree to all the contents of the <span style={{ color: "#ff4d6d", display: "contents", margin: "0 5px" }}> Terms of Use </span> and <span style={{ color: "#ff4d6d", display: "contents", margin: "0 5px" }}> Privacy Policy </span>
                  </label>
                  {errors.terms_accepted && <div className="field-error" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.terms_accepted}</div>}
                </div>

                <button
                  type="submit"
                  className="create-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Creating Account...' : 'Create Account'}
                </button>
              </form>

              <p className="login-text">
                Already have an account?  <Link to={"/login"}  >Log In</Link>
              </p>
            </div>

            <div className="image-section d-none d-lg-block">
              <img src={coupleImage} alt="Couple" />
              <div className="overlay-text">
                <h2 class="text-white">Your Journey To Love Begins <span className="highlight">Here !</span></h2>
                <p className='fw-bold text-center'>Connect With Genuine Matches Who <br />
                  Share Your <span className="highlight">Values</span> And <span className="highlight">Dreams.</span></p>
              </div>
            </div>
            <style>
              {`


   .page-container {
                    width: 100%;
                    min-height: 100vh;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #f5f5f5;
                    padding: 20px;
                }

                .login-container {
                    width: 100%;
                    max-width: 1200px;
                    background-color: white;
                    border-radius: 16px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
                    overflow: hidden;
                }

        .form-row {
          display: flex;
          margin-bottom: 5px;
          gap:3px 15px;
        }

        .form-row label {
          flex: 1;
        }

        .signup-wrapper {
          display: flex;
          min-height: 100vh;
          font-family: 'Arial', sans-serif;
        }
        
        .form-section {
          flex: 1;
          padding: 40px 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        
        .logo-img {
          width: 180px;
          margin-bottom: 40px;
        }
        
        h2 {
          font-size: 28px;
          margin-bottom: 10px;
          text-align: center;
        }
        
        .subtext {
          font-size: 16px;
          color: #555;
          margin-bottom: 25px;
          text-align: center;
        }
        
        .form label {
          display: flex;
          flex-direction: column;
          font-size: 14px;
          color: #333;
        }
        
        .form input, .form select {
          padding: 10px;
          margin-top: 3px;
          width:auto;
          border-radius: 15px;
          border: 1px solid #ccc;
          font-size: 15px;
          background:white;
        }
        
        .checkbox {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin: 10px 0 20px;
          font-size: 14px;
        }
        
        .checkbox input {
          margin-top: 5px;
        }
        
        .create-btn {
          padding: 12px;
          background-color: #ff4d6d;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
        }
        
        .create-btn:disabled {
          background-color: #ccc;
          cursor: not-allowed;
        }
        
        .login-text {
          text-align: center;
          margin-top: 20px;
          font-size: 14px;
        }
        
        .login-text a {
          color: #ff4d6d;
          text-decoration: none;
          font-weight: bold;
        }
        
        .image-section {
          flex: 1;
          position: relative;
          overflow: hidden;
          border-top-left-radius: 40px;
          border-bottom-left-radius: 40px;
          object-fit:contain;
              }
          .login-right {
  flex: 1;
  background-color: #fce6ea;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 500px;
}
        
        
        .image-section img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .overlay-text {
          position: absolute;
          bottom: 50px;
          color: white;
          max-width: 100%;
          text-shadow: 0 0 6px rgba(0, 0, 0, 0.7);
          padding:20px
        }
        
        .overlay-text h2 {
          font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 12px;
        }
        
        .overlay-text p {
          font-size: 16px;
          line-height: 1.4;
          color: white !important;
        }
        
        .highlight {
          color: #ffc107;
        }
        
        .checkbox label {
          display: flex;
          font-size: 14px;
          flex-direction: inherit;
          color: #333;
        }
        
        @media screen and (max-width: 900px) {
          .signup-wrapper {
            flex-direction: column;
          }
            .page-container{
            padding:13px;}
        
          .image-section {
            height: 300px;
            border-radius: 0;
          }
        
          .overlay-text {
            bottom: 20px;
            left: 20px;
          }
        
          .form-section {
            padding: 30px 15px;
          }

          .form-row{
          flex-direction:column;
          }

        }

        .form-row .form-group.mb-0{
        margin-bottom:0px !important;
        }


        `}
            </style>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignupForm;